import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountDialogService} from "../../../account/services/account-dialogs-service.service";
import {ContractsService} from "../../services/contracts-service.service";

export class ContractsTableRowCtrl implements IController {

  contract: any;
  accountId?:string; // only exists in the carrier drilldown
  isAddMode?: boolean;
  onViewContract: Function;
  onEditContractCarriers: Function;
  onContractDeleted: Function;
  onUnlinkContract: Function;
  onSetContractAsDefault: Function;
  onAdd: Function;


  public programTypesText: string;
  public enabledProgramId: string;

  /* @ngInject */
  constructor(private accountDialogService: AccountDialogService, private $state, private contractsService: ContractsService) {
  }

  $onInit() {
    this.enabledProgramId = undefined;
    if (this.contract) {
      this._setProgramTypesText(this.contract.entryList)
      this.enabledProgramId = _.find(this.contract.entryList, ((entry: any) => {
        return entry.enabled
      }))?.id
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.contract && !changes.contract.isFirstChange()) {
      this.$onInit();
    }
  }

  onShowAccounts(event, accountsArray) {
    this.accountDialogService.showAccountsList(event, accountsArray);
  }

  public onViewContractClicked() {
    const firstEnabledProgram = _.find(this.contract.entryList, ((entry: any) => {
      return entry.enabled
    }))
    this.onViewContract({contractId: this.contract.id, programId: firstEnabledProgram.id})
  }

  private _setProgramTypesText(entryList) {
    if (!entryList) {
      return;
    }
    this.programTypesText = '';
    _.forEach(entryList, (entry, index) => {
      if (entry.enabled && !!entry.programSetting) {
        this.programTypesText += `${index ? ',' : ''} ${entry.programSetting.name}`
      }
    })
  }


}

angular
  .module('bringoz.admin.contracts')
  .component( 'contractsTableRow', {
    bindings: {
      contract: '<',
      accountId: '<?',
      isAddMode: '<?',
      onViewContract: '&',
      onEditContractCarriers: '&',
      onRemoveCarrierFromContract: '&',
      onContractDeleted: '&',
      onUnlinkContract: '&?',
      onSetContractAsDefault: '&',
      onAdd: '&'
    },
    template: require('./contracts-table-row.html').default,
    controller: ContractsTableRowCtrl
  });

